module.exports = __webpack_public_path__ + "static/media/active-elderly.11c12563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/images/active-elderly.jpg
// module id = 548
// module chunks = 0